import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'afs-congratulation',
  styleUrl: 'afs-congratulation.sass',
  shadow: true,
})
export class AfsCongratulation {

  @Prop() heading : string = "CONGRATULATIONS TO OUR MONTHLY 50/50 WINNER!";
  @Prop() winningNumber : string = "X-8888888";
  @Prop() name : string = "Julie C.";
  @Prop() prize : number = 2160;
  @Prop() currency : string = "$";
  @Prop() drawDate : string = "December 31 2025";
  @Prop() backgroundColor : string = "#222222";
  @Prop() color : string = "#FFFFFF";

  @Element() el: HTMLElement;

  componentWillLoad() {
    let hostChildren = Array.from(this.el.children);
    hostChildren = [...hostChildren].filter(el => el.tagName == 'AFS-CONGRATULATION-LIST');
    hostChildren.forEach((element, index) => {
      if (index + 1 < hostChildren.length) {
        element.insertAdjacentHTML('afterend', `<hr style="height: 1px;background-color: ${this.color};border: none;" />`)
      }
    })
  }

  render() {
    return (
      <Host>
        <afs-section set-heading py-thick background-color={this.backgroundColor} color={this.color}>
          <h2 style={{color: this.color}} slot="heading">{ this.heading }</h2>
          <slot></slot>
          <br/>
          <slot name="button"></slot>
        </afs-section>
      </Host>
    );
  }

}
